<template>
<div class="app-footer ">
   <div class="row">
      <div class="col s10 offset-s1 yo-margin-bottom-xxs">
         <div class="col s12 yo-align-center sezione">
            <el-divider><span class="material-icons-outlined">search</span></el-divider> 
            <p class="yo-padding-top-xxs">SEARCH AREA</p>
            <p class="yo-padding-top-xxs yo-padding-bottom-xs yo-text-s">Looking for a specific topic/speaker?</p>
            
            <div class="col s10 offset-s1 yo-margin-top-xxs yo-margin-bottom-xs">
               <el-form ref="searchForm" :model="searchForm" :rules="rules" label-position="top" @submit.prevent="cerca">
               <!--<el-form ref="searchForm" :model="searchForm" @submit.prevent="cerca" :rules="rules">-->
                  <el-form-item prop="text">
                     <!--<el-autocomplete v-model="searchForm.text" :fetch-suggestions="querySearch" placeholder="Input some text to search" 
                        :trigger-on-focus="false" @select="handleSelect" @keyup.enter="handleSelect">
                        <template #default="{ item }">
                           <div class="row yo-padding-top yo-padding-bottom">
                              <div class="col s2 yo-valign-center" style="height: 34px"><img :src="item.imgcopertina.url" class="img-max" /></div>
                              <div class="col s9m offset-sm titolo-corso">{{item.titolo}}</div>
                           </div>
                        </template>
                     </el-autocomplete>-->
                     <el-input v-model="searchForm.text" placeholder="Search">
                        <template #suffix>
                           <span class="material-icons-outlined">search</span>
                        </template>
                     </el-input>
                  </el-form-item>
               </el-form>
            </div>
         </div>

         <div class="col s12 yo-align-center sezione">
            <el-divider><span class="material-icons-outlined">lock</span></el-divider> 
            <p class="yo-padding-top-xxs">LOGIN AREA</p>
            <p class="yo-padding-top-xxs yo-padding-bottom-xs yo-text-s">
               The contents of the EFLM e-learning platform are accessible to EFLM Academy Members only
            </p>
            <router-link to="/login" v-if="$teras.utente.id==undefined">
               <el-button class="yo-margin-top-xxs" type="info">ENTER</el-button>
            </router-link>
            <div class="col s12 yo-margin-top-xs" v-else>
               <el-button class="yo-margin-bottom-xs" type="info" @click="$teras.event.emit('logout')">EXIT</el-button>
               <p class="yo-padding-top-xs yo-color-primary-light">Logged as {{$teras.utente.nome}} {{$teras.utente.cognome}}</p>
            </div>
         </div>

         <div class="col s12 yo-align-center sezione" v-if="$teras.utente.id!=undefined">
            <el-divider><span class="material-icons-outlined">person</span></el-divider> 
            <p class="yo-padding-top-xxs">PERSONAL AREA</p>
            <p class="yo-padding-top-xxs yo-padding-bottom-xs yo-text-s">
               All your events and certificates in a click
            </p>
            <router-link to="/personal-area">
               <el-button class="yo-margin-top-xxs" type="info">ENTER</el-button>
            </router-link>
         </div>
      </div>

      <div class="col s10 offset-s1 yo-align-center yo-margin-top-xxs">
         <p class="yo-text-s yo-padding-top-xs yo-padding-bottom-xxxs">
            THE EFLM EDUCATIONAL PLATFORM IS MANTAINED THANKS TO THE UNCONDITIONAL SUPPORT OF
         </p>
         <div class="col s12 logo-sponsor">
            <img src="/site/images/snibe-logo.png" alt="Snibe" width="140" height="66" />
         </div>
      </div>
   </div>
</div>
</template>

<script>
import Schema from 'async-validator';
import { ElDivider, ElForm, ElFormItem, ElInput, ElButton } from "element-plus"
Schema.warning = function(){};
export default {
   name: 'site-footer',
   components: {
     ElDivider, ElForm, ElFormItem, ElInput, ElButton
   },
   data(){
      return{
         searchForm: {
            text: ''
         }
      }
   },
   methods: {
      cerca(){
         this.$refs['searchForm'].validate((valid) => {
            if(valid){
               this.$router.push('/search/'+this.searchForm.text)
            }
         })
      }
   },
   computed: {
      rules: function () {
         return {
            text: [
               {required: true, message: 'The search text is mandatory', trigger: 'change'}
            ]
         }
      }
   }
}
</script>